import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from "@/components/Login.vue"
import Inactive from "@/components/Inactive.vue"

import Dashboard from "@/views/customer/Dashboard.vue"
import Library from "@/views/customer/Library.vue"
import Explore from "@/views/customer/Explore.vue"
import Favorites from "@/views/customer/Favorites.vue"
import Account from "@/views/customer/Account.vue"
import Billing from "@/views/customer/Billing.vue"
import Payment from "@/views/customer/Payment.vue"

import AdminUsersPage from "@/views/admin/Users.vue"
import AdminCategoriesPage from "@/views/admin/Categories.vue"
import AdminVideosPage from "@/views/admin/Videos.vue"
import AdminComponentsPage from "@/views/admin/Components.vue"
import AdminPlansPage from "@/views/admin/Plans.vue"
import AdminSettingsPage from "@/views/admin/Settings.vue"

Vue.use(VueRouter)

  const routes = [
    /* Global */
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/inactive',
      name: 'Inactive',
      component: Inactive
    },
    /* Customer */
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/library',
      name: 'Library',
      component: Library
    },
    {
      path: '/explore',
      name: 'Explore',
      component: Explore
    },
    {
      path: '/favorites',
      name: 'Favorites',
      component: Favorites
    },
    {
      path: '/my-account',
      name: 'Account',
      component: Account
    },
    {
      path: '/billing',
      name: 'Billing',
      component: Billing
    },
    {
      path: '/payment',
      name: 'Payment',
      component: Payment
    },
    /* Admin */
    {
      path: '/admin/users',
      name: 'AdminUsers',
      component: AdminUsersPage
    },
    {
      path: '/admin/categories',
      name: 'AdminCategories',
      component: AdminCategoriesPage
    },
    {
      path: '/admin/components',
      name: 'AdminComponents',
      component: AdminComponentsPage
    },
    {
      path: '/admin/plans',
      name: 'AdminPlans',
      component: AdminPlansPage
    },
    {
      path: '/admin/videos',
      name: 'AdminVideos',
      component: AdminVideosPage
    },
    {
      path: '/admin/settings',
      name: 'AdminSettings',
      component: AdminSettingsPage
    },
]

const router = new VueRouter({
  routes
})

export default router
